import { skipToken, useQuery } from "@tanstack/react-query";
import {
  type ComgateCommentDto,
  getMerchantsPublicIDOrbitLComgateComments,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const COMGATE_COMMENTS_QUERY_KEY = "COMGATE_COMMENTS";

export const comgateCommentsKeys = {
  all: [COMGATE_COMMENTS_QUERY_KEY],
  byMerchantPublicId: (merchantPublicID?: string) => [
    ...comgateCommentsKeys.all,
    merchantPublicID,
  ],
};

export const useGetComgateCommentsQuery = (merchantPublicID?: string) =>
  useQuery<Array<ComgateCommentDto>>({
    queryKey: comgateCommentsKeys.byMerchantPublicId(merchantPublicID),
    queryFn: merchantPublicID
      ? processResponseWithApiProblemDetails(() =>
          getMerchantsPublicIDOrbitLComgateComments(merchantPublicID),
        )
      : skipToken,
  });
